import React, { useContext, useEffect, useMemo } from "react";

import Modal from "../../../atoms/Modal";
import BAWorkAnswerList from "../BAWorkAnswerList";
import {
  Context,
  fetchBAWorkAnswers,
  fetchBAWorkAnswersFromOtherSchools,
  fetchClasses,
  fetchGroups,
  nameClosedBAWork,
  nameOpenedBAWork,
} from "../../../teacherStore";

import styles from "./BAWorkAnswersModal.module.scss";

type Props = {
  oppaId: number;
  classList: number[];
  onCloseModal: () => void;
};

const BAWorkAnswersModal = ({ oppaId, classList, onCloseModal }: Props) => {
  const { state, dispatch } = useContext(Context);

  useEffect(() => {
    const refreshAnswers = () => {
      dispatch(fetchBAWorkAnswers(oppaId, classList));
    };

    refreshAnswers();

    const refetchInterval = setInterval(() => refreshAnswers(), 10000);
    return () => clearInterval(refetchInterval);
  }, [dispatch, oppaId, classList]);

  useEffect(() => {
    dispatch(fetchBAWorkAnswersFromOtherSchools(oppaId, classList));
  }, [dispatch, oppaId, classList]);

  useEffect(() => {
    dispatch(fetchGroups(classList));
    dispatch(fetchClasses());
  }, [dispatch, classList]);

  const answersWithIndex = useMemo(() => {
    return state.one_page_portfolio_assessment_answers_by_classes.map(
      answersByClass => {
        const answers = answersByClass.answers.map((answer, index) => {
          const haveAnswers = answer.one_page_portfolio_assessments
            ?.filter(oppa => oppa.id === oppaId)
            .flatMap(oppa => oppa.one_page_portfolio_assessment_issues)
            .flatMap(issue => issue.one_page_portfolio_assessment_questions)
            .some(
              question =>
                question.one_page_portfolio_assessment_answers.length > 0,
            );

          const questionAnswers =
            answer.one_page_portfolio_assessments
              ?.flatMap(oppa => oppa.one_page_portfolio_assessment_issues)
              .flatMap(
                issue => issue.one_page_portfolio_assessment_questions,
              ) ?? [];

          return {
            student: answer.student,
            index: index + 1,
            have_answers: haveAnswers,
            one_page_portfolio_assessments_question_answers: questionAnswers,
          };
        });
        return { ...answersByClass, answers };
      },
    );
  }, [state.one_page_portfolio_assessment_answers_by_classes, oppaId]);

  const changeNameOpenClose = (class_id: number, opened: boolean) => {
    opened
      ? dispatch(nameOpenedBAWork(oppaId, class_id))
      : dispatch(nameClosedBAWork(oppaId, class_id));
  };

  return (
    <Modal centered onClose={onCloseModal} className={styles.modal}>
      <div className={styles.content}>
        <BAWorkAnswerList
          answersByClasses={answersWithIndex}
          answersOtherSchoolsByClasses={
            state.one_page_portfolio_assessment_answers_from_other_school_by_classes
          }
          classes={state.classes}
          classList={classList}
          groups={state.groups}
          changeNameOpenClose={changeNameOpenClose}
        />
      </div>
    </Modal>
  );
};
export default BAWorkAnswersModal;
